import { IScoreCardRowOption } from '../models/score-cards/score-cards.interface'

export const ROUND_INITIAL_OPTIONS: IScoreCardRowOption[] = [
  {
    name: 'Fault',
  },
  {
    name: 'D',
  },
  {
    name: 'RT',
  },
  {
    name: 'F',
  },
  {
    name: 'R1',
  },
  {
    name: 'R2',
  },
]

export const ROUND_OPTIONS_PROPS = {
  Fault: {
    label: 'Faults',
    type: 'button',
    className: 'flex-1 min-w-[148px]',
  },
  D: {
    label: 'Displac.',
    type: 'button',
    className: 'w-[56px] min-w-[56px] bg-SeabiscuitGrayThemeColor',
  },
  RT: {
    label: 'Retired',
    type: 'button',
    className: 'w-[56px] min-w-[56px] bg-SeabiscuitGrayThemeColor',
  },
  F: {
    label: 'Fall',
    type: 'button',
    className: 'w-[56px] min-w-[56px] bg-SeabiscuitGrayThemeColor',
  },
  R1: {
    label: 'Refusal 1',
    type: 'button',
    className: 'w-[56px] min-w-[56px] bg-SeabiscuitGrayThemeColor',
  },
  R2: {
    label: 'Refusal 2',
    type: 'button',
    className: 'w-[56px] min-w-[56px] bg-SeabiscuitGrayThemeColor',
  },
}

export const INITIAL_SECTION = {
  maxTime: null,
  totalFaultsCount: 0,
  totalFaultsStatus: '',
  totalTime: 0,
  totalTimeFaults: 0,
}

export const INITIAL_ROW = {
  description: '',
  options: ROUND_INITIAL_OPTIONS,
}

export const fenceHeightOptions = [
  { label: 'Poles', value: 'Poles', disable: true },
  { label: '18”', value: '18”', disable: false },
  { label: '2’0”', value: '2’0”', disable: false },
  { label: '2’3”', value: '2’3”', disable: false },
  { label: '2’6”', value: '2’6”', disable: false },
  { label: '2’9”', value: '2’9”', disable: false },
  { label: '3’0”', value: '3’0”', disable: false },
  { label: '3’3”', value: '3’3”', disable: false },
  { label: '3’6”', value: '3’6”', disable: false },
  { label: '3’9”', value: '3’9”', disable: false },
  { label: '4’0”', value: '4’0”', disable: false },
  { label: '0.70m', value: '0.70m', disable: false, isBorderTop: true },
  { label: '0.75m', value: '0.75m', disable: false },
  { label: '0.80m', value: '0.80m', disable: false },
  { label: '0.85m', value: '0.85m', disable: false },
  { label: '0.90m', value: '0.90m', disable: false },
  { label: '0.95m', value: '0.95m', disable: false },
  { label: '1.00m', value: '1.00m', disable: false },
  { label: '1.05m', value: '1.05m', disable: false },
  { label: '1.10m', value: '1.10m', disable: false },
  { label: '1.15m', value: '1.15m', disable: false },
  { label: '1.20m', value: '1.20m', disable: false },
  { label: '1.25m', value: '1.25m', disable: false },
  { label: '1.30m', value: '1.30m', disable: false },
  { label: '1.35m', value: '1.35m', disable: false },
  { label: '1.40m', value: '1.40m', disable: false },
  { label: '1.45m', value: '1.45m', disable: false },
  { label: '1.50m', value: '1.50m', disable: false },
  { label: '1.55m', value: '1.55m', disable: false },
  { label: '1.60m', value: '1.460m', disable: false },
  { label: 'N - National', value: 'N - National', disable: false },
  { label: 'H - High Performance', value: 'H - High Performance', disable: false },
  { label: 'A - American', value: 'A - American', disable: false },
  { label: 'R - Regional', value: 'R - Regional', disable: false },
]
